import { render, staticRenderFns } from "./LaudoGeralModal.vue?vue&type=template&id=3a918a3e&scoped=true&lang=pug"
import script from "./LaudoGeralModal.vue?vue&type=script&lang=js"
export * from "./LaudoGeralModal.vue?vue&type=script&lang=js"
import style0 from "./LaudoGeralModal.vue?vue&type=style&index=0&id=3a918a3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a918a3e",
  null
  
)

export default component.exports